import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {
  document,
  relation,
} from 'src/app/modules/cases/components/create-case/ras-form/ras-form.utils';
import { ConfirmDeleteRasComponent } from '../../confirm-delete-ras/confirm-delete-ras.component';
enum Texts {
  otherPerson = 'Otras personas relacionadas en el reporte',
  nameLabel = 'Nombre y apellido / Razón social *',
  nIdentification = 'Tipo de identificación',
}
@Component({
  selector: 'other-person',
  templateUrl: './other-person.component.html',
  styleUrls: ['./other-person.component.scss'],
})
export class OtherPersonComponent implements OnInit {
  public Texts = Texts;
  relation = relation;
  document = document;
  @Input() form: FormGroup;
  @Output() formChange = new EventEmitter<FormGroup>();

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog
  ) {}

  personForm = this.fb.group({
    name: ['', [Validators.required]],
    document: ['', [Validators.required]],
    relation: ['', [Validators.required]],
    nationality: ['', [Validators.required]],
  });

  persons = [];

  displayedColumns: string[] = [
    'name',
    'nationality',
    'document',
    'relation',
    'options',
  ];
  dataSource;

  ngOnInit() {
    const { otherPerson } = this.form.value;
    if (otherPerson?.length > 0) {
      this.persons = otherPerson;
      this.dataSource = new MatTableDataSource(this.persons);
    }
  }

  editing = null;

  setToEdit(index) {
    const values = this.persons[index];
    this.editing = index;
    this.personForm.patchValue(values);
  }

  edit() {
    const values = this.personForm.value;
    this.persons[this.editing] = values;
    this.personForm.reset();
    this.updateItems();
    this.editing = null;
  }

  cancelEdit() {
    this.personForm.reset();
    this.editing = null;
  }

  delete(index) {
    this.dialog
      .open(ConfirmDeleteRasComponent, {
        data: { title: '¿Seguro que deseas eliminar a esta persona?' },
      })
      .afterClosed()
      .subscribe({
        next: (result) => {
          if (result) {
            this.persons.splice(index, 1);
            this.updateItems();
          }
        },
      });
  }

  updateItems() {
    this.dataSource = new MatTableDataSource(this.persons);
    this.form.controls.otherPerson.setValue(this.persons);
    this.formChange.emit(this.form);
  }

  add() {
    const values = this.personForm.value;
    this.persons.push(values);
    this.personForm.reset();
    this.updateItems();
  }
}
